import React, { useState, useEffect, useCallback } from 'react';
import { Input, Row } from "react-materialize";
import { bindActionCreators } from "redux";
import debounce from "lodash/debounce";
import connect from "react-redux/es/connect/connect";

import getQuotationOptionsThunk from "../../actions/workflow/isdnMigrationActions/getQuotationOptionsThunk";
import updateQuotationOptionsThunk from "../../actions/workflow/isdnMigrationActions/updateQuotationOptionsThunk";
import quotationActions from "../../actions/quotationActions";
import partnerServicesActions from "../../actions/partnerServicesActions";

import InputNumberWrapper from "./InputNumberWrapper";

const ITKPNServiceOption = (props) => {
  const [products, setProducts] = useState([]);
  const [selections, setSelections] = useState([]);

  // Debounced save function
  const debouncedSaveSelections = useCallback(
      debounce((selections, quotationId, type) => {
        const { itServicesSelections } = props.partnerServices;

        const allSelections = itServicesSelections.filter(selection => selection.category !== props.authentication.kpnITServiceOption.category);
        const newSelections = [...allSelections, ...selections];

        props.partnerServicesActions.persistPartnerServicesSelections(newSelections, quotationId, type).then(() => {
          props.partnerServicesActions.setITServiceSelection(newSelections);
        });
      }, 1000),
      [props.partnerServices, props.authentication, props.partnerServicesActions]
  );

  // Initial setup effect
  useEffect(() => {
    const KPNITServiceOption = props.authentication.kpnITServiceOption;
    const isSalesValue = props.authentication.isSalesValue;
    let initialProducts = [];

    if (KPNITServiceOption) {
      if (isSalesValue) {
        initialProducts = props.partnerServices.productsToLink.microsoftProducts;
      } else {
        initialProducts = props.partnerServices.productsToLink.products.filter((product) => {
          return product.offer && parseInt(product.offer.id) === KPNITServiceOption.offer_id && KPNITServiceOption.product_categories_ids.includes(parseInt(product.product_category));
        });
      }
    }

    const initialSelections = props.partnerServices.itServicesSelections;

    setProducts(initialProducts);
    setSelections(initialSelections.filter(selection => selection.category === KPNITServiceOption.category));
  }, []);

  // Update selections when props change
  useEffect(() => {
    const newSelections = props.partnerServices.itServicesSelections;
    const KPNITServiceOption = props.authentication.kpnITServiceOption;

    setSelections([...newSelections.filter(selection => selection.category === KPNITServiceOption.category)]);
  }, [props.partnerServices.itServicesSelections, props.authentication.kpnITServiceOption]);

  const saveSelections = (selectionsToSave, quotationId, type) => {
    debouncedSaveSelections(selectionsToSave, quotationId, type);
  };

  const addOption = () => {
    if (props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    const { allowDecimalQuantity } = props;

    const quantityStep = allowDecimalQuantity ? 0.01 : 1;

    const newSelections = [...selections, {
      id: '',
      quantity: quantityStep,
      category: ''
    }];

    setSelections(newSelections);
  };

  const removeOption = (index) => {
    if (props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    const newSelections = [...selections];
    newSelections.splice(index, 1);

    saveSelections(newSelections, props.quotation.currentQuotation.id, 'it');
    setSelections(newSelections);
  };

  const onChange = (event, index) => {
    if (props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    const { value } = event.target;
    const newSelections = [...selections];
    const { allowDecimalQuantity } = props;

    newSelections[index].id = parseInt(value);
    newSelections[index].category = props.authentication.kpnITServiceOption.category;

    const foundSelectedIndex = newSelections.findIndex((selection, idx) => selection.id === parseInt(value) && idx !== index);
    if (foundSelectedIndex !== -1) {

      if (newSelections[foundSelectedIndex].quantity >= 999) {
        return;
      }

      if (allowDecimalQuantity) {
        newSelections[index].quantity = (parseFloat(newSelections[index].quantity)
            + parseFloat(newSelections[foundSelectedIndex].quantity)).toFixed(2);
      } else {
        newSelections[index].quantity = parseInt(newSelections[index].quantity)
            + parseInt(newSelections[foundSelectedIndex].quantity);
      }

      newSelections.splice(foundSelectedIndex, 1);
    }

    setSelections(newSelections);

    saveSelections(newSelections, props.quotation.currentQuotation.id, 'it');
  };

  const changeQuantity = (event, index) => {
    if (props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    let { value, min, max } = event.target;
    let newSelections = [...selections];

    value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    newSelections[index].quantity = parseInt(value).toString();

    setSelections(newSelections);

    //filter selections to not send null ids
    newSelections = newSelections.filter(selection => selection.id != null) || [];

    saveSelections(newSelections, props.quotation.currentQuotation.id, 'it');
  };

  const changeDecimalQuantity = (value, index) => {
    if (props.quotation.currentQuotation.inputsDisabled) {
      return;
    }
    let newSelections = [...selections];

    newSelections[index].quantity = value;

    setSelections(newSelections);

    //filter selections to not send null ids
    newSelections = newSelections.filter(selection => selection.id != null) || [];

    saveSelections(newSelections, props.quotation.currentQuotation.id, 'it');
  };

  const renderQuantityInput = (option, index) => {
    const { allowDecimalQuantity } = props;
    const quantityStep = allowDecimalQuantity ? 0.01 : 1;
    let optionQuantity = option.quantity ? option.quantity : 1;
    const { inputsDisabled } = props.quotation.currentQuotation;

    return (
        !allowDecimalQuantity ?
            <Input
                s={1}
                style={{ marginBottom: selections?.length > 1 ? '15px' : null }}
                type="number"
                label={index === 0 ? 'aantal' : ''}
                value={optionQuantity}
                onChange={(e) => {
                  changeQuantity(e, index)
                }}
                step={quantityStep}
                min={quantityStep}
                max={999}
                disabled={inputsDisabled}
            /> :
            <InputNumberWrapper
                s={1}
                style={{ marginBottom: selections?.length > 1 ? '15px' : null }}
                label={index === 0 ? 'aantal' : ''}
                optionQuantity={optionQuantity}
                index={index}
                changeDecimalQuantity={changeDecimalQuantity}
                step={quantityStep}
                min={quantityStep}
                max={999}
                precision={2}
                className={'col input-field s1'}
                inputsDisabled={inputsDisabled}
            />
    );
  };

  const { allowDecimalQuantity } = props;
  const { inputsDisabled } = props.quotation.currentQuotation;

  const quantityStep = allowDecimalQuantity ? 0.01 : 1;

  // Ensure there's always at least one selection
  const displaySelections = selections.length ? selections : [{
    id: "",
    quantity: quantityStep,
    category: props.authentication.kpnITServiceOption?.category || ''
  }];

  return (
      <fieldset disabled={inputsDisabled} style={{ border: 'none', padding: 'unset', margin: 'unset' }}>
        <div className="row">
          <h1 className={'ratio-section-title'} style={{ marginTop: 0 }}>
          <span className="ratio-section-title">
            <i className="small material-icons left ratio-section-title">call_merge</i>IT Diensten
          </span> Microsoft
          </h1>
        </div>

        {displaySelections.map((option, index) => {
          return (
              <div className="row" key={`${index}`} style={{ marginBottom: 0 }}>
                {option.id > 0 && renderQuantityInput(option, index)}

                <Input
                    s={!option?.id ? 8 : 7}
                    className={displaySelections?.length > 1 && !(displaySelections?.length - 1 === index) ? "ratio-input" : ''}
                    name='product'
                    type='select'
                    label={index === 0 ? 'Kies de gewenste Microsoft IT dienst' : ''}
                    value={option.id}
                    onChange={(e) => { onChange(e, index) }}
                    multiple={false}
                    disabled={inputsDisabled}
                >
                  <option value="">Selecteer</option>
                  {products.map((optionItem) => <option key={optionItem.id} value={optionItem.id}>{optionItem.name}</option>)}
                </Input>

                <button
                    className='btn doceri-btn-right ratio-btn-right'
                    onClick={() => removeOption(index)}
                    style={{ float: 'left', marginLeft: 10 }}
                    disabled={inputsDisabled}
                >
                  Verwijder
                </button>

                {displaySelections.length - 1 === index &&
                    <button className="btn doceri-btn-right ratio-btn-right" onClick={addOption} disabled={inputsDisabled}>
                      Microsoft IT dienst toevoegen
                    </button>
                }
              </div>
          );
        })}
      </fieldset>
  );
};

const mapStateToProps = ({ quotation, quotationOptions, partnerServices, authentication }) => {
  return {
    quotation,
    quotationOptions,
    partnerServices,
    authentication
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getQuotationOptions: bindActionCreators(getQuotationOptionsThunk, dispatch),
    updateQuotationOptions: bindActionCreators(updateQuotationOptionsThunk, dispatch),
    quotationActions: bindActionCreators(quotationActions, dispatch),
    partnerServicesActions: bindActionCreators(partnerServicesActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ITKPNServiceOption);